import { I375Form } from 'clickNgo/models/crud/forms'

import { IContact } from '../model/types'

export enum ContactRole {
  PartnerSigner = 'Partner Signer',
  HPChampion = 'HP Champion',
  LRChampion = 'L&R Champion',
  GeneralManager = 'General Manager',
}

export const HIERARCHY_TYPE_MANDATORY_HP_ROLE_LIST = ['Partner Signer', 'L&R Champion']
export const UNIQUE_ROLES = ['HP Champion', 'Partner Signer', 'L&R Champion']
export const GENERAL_HP_ROLE_LIST = [
  'HP Champion',
  'Partner Signer',
  'L&R Champion',
  'General Manager',
]

export const IMPORTANT_CONTACT_ROLES = ['General Manager']
export const HP_IMPORTANT_TOOLS_FLAG = ['PFP Admin(PPA)']
export const HP_IMPORTANT_USER_RIGHTS_FLAG = ['G_UPP_Partner_Admin_User']

export const externalFieldNames: { [key in keyof Partial<I375Form>]: keyof IContact } = {
  CountryOfBusiness: 'countryOfBusiness',
  Email: 'email',
  EmailPixels: 'emailPixels',
  FirstName: 'firstName',
  LastName: 'lastName',
  MobilePhone: 'mobilePhoneNumber',
  MobilePhone_Prefix: 'mobilePhoneCode',
  NeverCall: 'isNeverCall',
  NeverEmail: 'isNeverEmail',
  PR_HP_ROLE: 'hpRoles',
  PreferredLanguage: 'preferredLanguage',
  Salutation: 'salutation',
  Seniority: 'seniority',
  Status: 'status',
  WorkPhone: 'workPhoneNumber',
  WorkPhone_Prefix: 'workPhoneCode',
  ModifiedValues: 'modifiedValues',
  PrimaryJobRole: 'primaryJobRole',
}
